module.exports = __webpack_public_path__ + "img/Honigloeffel-v1-500.3d901eef.png";